module.exports = __webpack_public_path__ + "img/4.ffe37930.svg";